import { createAction, props } from '@ngrx/store';

export const getSessionUser = createAction('getSessionUser');
export const setSessionUser = createAction('setSessionUser', props<any>());
export const removeSessionUser = createAction('removeSessionUser');